/**
 * @desc 保存平台店铺应用表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.appAccount.save.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/appAccount/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
